// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CONTENEDOR GENERAL */
.container-menu {
    position: relative;
    display: inline-block;
}

/* DROPDOWN */
.dropdown-menu {
    position: absolute;
    right: 0;
    top: 45px;
    width: 240px;
    background: var(--bg-card);
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    z-index: 20;
    animation: fadeIn 0.18s ease-in-out;
    font-family: var(--font-principal);
    border: 1px solid var(--color-borders);
    padding: 0px;
    overflow: hidden;
}

/* Animación */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* HEADER DEL USUARIO */
.dropdown-item-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 15px;
    font-weight: 600;
    font-size: 0.9em;
    color: var(--primary-blue);
    border-bottom: 1px solid var(--color-borders);
}

.truncate-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
}

.dropdown-item-header .dropdown-icon {
    font-size: 20px;
    opacity: 0.85;
}

/* ITEMS DEL MENÚ (Links y Botones) */
.dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    gap: 10px;
    text-decoration: none;
    font-size: 0.9em;
    color: var(--texto-principal);
    transition: background 0.2s ease, color 0.2s ease;
    font-family: var(--font-principal);
    margin: 5px;
    border-radius: 8px;
    
    /* Reset para botones */
    background: transparent;
    border: none;
    width: calc(100% - 10px);
    text-align: left;
    cursor: pointer;
}

/* ÍCONOS */
.dropdown-icon {
    font-size: 18px;
    opacity: 0.85;
    color: var(--color-gray-text); 
}

.user-icon {
    color: var(--primary-blue);
}

/* HOVER GENERAL */
.dropdown-item:hover {
    background: rgba(80, 56, 237, 0.08);
    color: var(--primary-blue);
}

.dropdown-item:hover .dropdown-icon {
    color: var(--primary-blue);
}

/* SEPARADOR */
.dropdown-separator {
    margin: 5px 0;
    border-top: 1px solid var(--color-borders);
}

/* ITEM DE TEMA */
.theme-item {
    font-weight: 500;
}

/* CERRAR SESIÓN ROJO */
.logout-item {
    color: var(--score-rojo);
    font-weight: 600;
}

.logout-item .dropdown-icon {
    color: var(--score-rojo);
}

.logout-item:hover {
    background: rgba(239, 68, 68, 0.12);
    color: #b20000;
}

.logout-item:hover .dropdown-icon {
    color: #b20000;
}`, "",{"version":3,"sources":["webpack://./src/components/UserMenu/userMenu.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,mCAAmC;IACnC,kCAAkC;IAClC,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;IAC7B,iDAAiD;IACjD,kCAAkC;IAClC,WAAW;IACX,kBAAkB;;IAElB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,cAAc;AACd;IACI,aAAa;IACb,0CAA0C;AAC9C;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* CONTENEDOR GENERAL */\r\n.container-menu {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n/* DROPDOWN */\r\n.dropdown-menu {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 45px;\r\n    width: 240px;\r\n    background: var(--bg-card);\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    z-index: 20;\r\n    animation: fadeIn 0.18s ease-in-out;\r\n    font-family: var(--font-principal);\r\n    border: 1px solid var(--color-borders);\r\n    padding: 0px;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Animación */\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-6px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* HEADER DEL USUARIO */\r\n.dropdown-item-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 15px 15px;\r\n    font-weight: 600;\r\n    font-size: 0.9em;\r\n    color: var(--primary-blue);\r\n    border-bottom: 1px solid var(--color-borders);\r\n}\r\n\r\n.truncate-name {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 160px;\r\n}\r\n\r\n.dropdown-item-header .dropdown-icon {\r\n    font-size: 20px;\r\n    opacity: 0.85;\r\n}\r\n\r\n/* ITEMS DEL MENÚ (Links y Botones) */\r\n.dropdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 12px 15px;\r\n    gap: 10px;\r\n    text-decoration: none;\r\n    font-size: 0.9em;\r\n    color: var(--texto-principal);\r\n    transition: background 0.2s ease, color 0.2s ease;\r\n    font-family: var(--font-principal);\r\n    margin: 5px;\r\n    border-radius: 8px;\r\n    \r\n    /* Reset para botones */\r\n    background: transparent;\r\n    border: none;\r\n    width: calc(100% - 10px);\r\n    text-align: left;\r\n    cursor: pointer;\r\n}\r\n\r\n/* ÍCONOS */\r\n.dropdown-icon {\r\n    font-size: 18px;\r\n    opacity: 0.85;\r\n    color: var(--color-gray-text); \r\n}\r\n\r\n.user-icon {\r\n    color: var(--primary-blue);\r\n}\r\n\r\n/* HOVER GENERAL */\r\n.dropdown-item:hover {\r\n    background: rgba(80, 56, 237, 0.08);\r\n    color: var(--primary-blue);\r\n}\r\n\r\n.dropdown-item:hover .dropdown-icon {\r\n    color: var(--primary-blue);\r\n}\r\n\r\n/* SEPARADOR */\r\n.dropdown-separator {\r\n    margin: 5px 0;\r\n    border-top: 1px solid var(--color-borders);\r\n}\r\n\r\n/* ITEM DE TEMA */\r\n.theme-item {\r\n    font-weight: 500;\r\n}\r\n\r\n/* CERRAR SESIÓN ROJO */\r\n.logout-item {\r\n    color: var(--score-rojo);\r\n    font-weight: 600;\r\n}\r\n\r\n.logout-item .dropdown-icon {\r\n    color: var(--score-rojo);\r\n}\r\n\r\n.logout-item:hover {\r\n    background: rgba(239, 68, 68, 0.12);\r\n    color: #b20000;\r\n}\r\n\r\n.logout-item:hover .dropdown-icon {\r\n    color: #b20000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
